import type CK from '~/types/contentking';

import {
	useAccountBillingCycleQuery,
} from './useAccountBillingCycle.gql';

import useAccountPropertiesQuery from '~/hooks/useAccountPropertiesQuery';



function useAccountBillingCycle(accountId: CK.AccountId | null) {
	const { data } = useAccountPropertiesQuery(
		useAccountBillingCycleQuery,
		accountId,
	);

	return data?.account?.billingCycle ?? null;
}



export default useAccountBillingCycle;
